import { PrimaryBtn } from "../../../components/index";
import "./HorizontalSec.scss";
import { useRef, useEffect, useState } from "react";
import { baseUrl } from "../../../utils/apiData";
import { useNavigate } from "react-router-dom";
import { images } from "../../../utils/images";

const HorizontalSec = ({ dataList }) => {
  const navigate = useNavigate();
  const landscapRef = useRef();
  const [width, setWidth] = useState(0);
  const measureWidth = () => {
    if (landscapRef.current) {
      const rect = landscapRef.current.getBoundingClientRect();
      setWidth(rect.width);
    }
  };

  useEffect(() => {
    measureWidth();
    window.addEventListener("resize", measureWidth);
    return () => {
      window.removeEventListener("resize", measureWidth);
    };
  }, []);

  const spaceRef = useRef();
  const [move, setMove] = useState(0);

  const handleScroll = () => {
    if (spaceRef.current) {
      const rect = spaceRef.current.getBoundingClientRect();
      const scrollTop = window.scrollY;
      const distance = rect.top + scrollTop;

      setMove(
        scrollTop - distance + window.innerHeight > 0
          ? scrollTop - distance + window.innerHeight > 3 * window.innerWidth
            ? 3 * window.innerWidth
            : Math.max(
                scrollTop - distance + window.innerHeight,
                width - window.innerWidth
              )
          : 0
      );
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <section className="horizontal_sec">
        <img
          src={images.densePattern}
          alt="Pattern"
          className="bg_pattern"
          style={{ opacity: "0.1" }}
        />
        <div
          className="horizontal_slide_line"
          ref={landscapRef}
          style={{
            transform: `translateX(${-move}px)`,
          }}
        >
          {dataList?.map((data) => {
            return (
              <div className="bi_sec" key={data?._id}>
                <div className="text_content p_t p_b">
                  <p className="tag_title darkGold">{data?.heading}</p>
                  <h4 className="darkGold">{data?.title}</h4>
                  <div
                    className="info"
                    dangerouslySetInnerHTML={{ __html: data?.description }}
                  />
                  <PrimaryBtn
                    theme="gold"
                    title="Know More"
                    clickHandler={() =>
                      navigate(`project/${data?.project?.slug}`)
                    }
                  />
                </div>
                <div className="right">
                  <div className="img_wrap">
                    <img
                      src={`${baseUrl}/${data?.main_image}`}
                      alt="Our Site"
                    />
                  </div>
                  <div className="small_img">
                    <img src={`${baseUrl}/${data?.image}`} alt="Our Site" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <div
        className="complement_space"
        style={{ height: `${width - window.innerWidth}px` }}
        ref={spaceRef}
      ></div>

      <section className="lap_size p_t">
        <img
          src={images.densePattern}
          alt="Pattern"
          className="bg_pattern"
          style={{ opacity: "0.1" }}
        />

        <div className="content_wrap">
          <div className="sec_title">
            {dataList?.map((data) => {
              return (
                <div className="project_sec">
                  <div className="img_wrap">
                    <img
                      src={`${baseUrl}/${data?.main_image}`}
                      alt="Our Site"
                    />
                  </div>
                  <div className="text_content p_b mt-4 pt-2">                  
                    <h4 className="darkGold">{data?.title}</h4>
                    <div
                      className="info"
                      dangerouslySetInnerHTML={{ __html: data?.description }}
                    />
                    <PrimaryBtn
                      theme="gold"
                      title="Know More"
                      clickHandler={() =>
                        navigate(`project/${data?.project?.slug}`)
                      }
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HorizontalSec;
